// This is now a reference to the faqItem document
export default {
	name: 'faq',
	title: 'FAQ Reference',
	type: 'reference',
	to: [{ type: 'faqItem' }],
};
